import {useCommand} from 'hooks';
import {useVehicleProjectsTranslation} from '../../VehicleProjects/hooks/vehicleProjectsTranslationHooks';
import {IContextualMenuItem as MenuItem} from '@fluentui/react';
import {useUserContext, UserContextType} from 'authentication/UserContext';
import {useMemo} from 'react';
import {useBoolean} from '@fluentui/react-hooks';
import {BooleanState} from 'types/fluentUi';

import {ProjectDetailsPageParams} from 'features/VehicleProjects/vehicleProjectPagePaths';
import {
	NavigateToBaselineListPage,
	useNavigateToBaselineListPage,
} from './BaselinesPage.utils';
import {Baseline} from 'types';

export interface BaselineCmdsInfo {
	infoForIsSuccessDialogOpen: BooleanState;
}

interface Options {
	params: ProjectDetailsPageParams;
}

export const useBaselineListCmds = (
	{params}: Options,
	baselines: Baseline[],
	setRenameDialogOpen: (isOpen: boolean) => void,
): BaselineCmdsInfo => {
	const {isAdmin}: UserContextType = useUserContext();
	const {t} = useVehicleProjectsTranslation({keyPrefix: 'BaselineCmds'});
	const navigateToBaselinesPage: NavigateToBaselineListPage =
		useNavigateToBaselineListPage(params);

	const infoForIsSuccessDialogOpen: BooleanState = useBoolean(false);
	const [, {setTrue: setVisible}] = infoForIsSuccessDialogOpen;

	useCommand(
		{
			key: 'BaselineRename',
			text: t('BaselineRename'),
			onClick() {
				setRenameDialogOpen(true);
			},
			iconProps: {iconName: 'Edit'},

			disabled: baselines.length === 0,
			priority: 10,
		},
		[baselines],
	);

	return {
		infoForIsSuccessDialogOpen,
	};
};
